import { isUndefined } from "lodash";
import getListBrands from "./getListBrands";
import sortBrands from "./sortBrands";

export default function getListBrandsGroups(data, brandIds) {
  let proprietary = [];
  let franchise = [];
  let virtual = [];

  for (let item of data) {
      if (!isUndefined(item.field_type[0])) {
          switch (item.field_type[0].value) {
              case 'proprietary':
                  proprietary.push(item);
                  break;
              case 'franchise':
                  franchise.push(item);
                  break;
              case 'virtual':
                  virtual.push(item);
                  break;
          }
      }
  }
  return {
        proprietary: sortBrands(getListBrands(proprietary), brandIds),
        franchise: sortBrands(getListBrands(franchise), brandIds),
        virtual: sortBrands(getListBrands(virtual), brandIds),
    };
}
